<template></template>

<script>

import XLSX from 'xlsx'

export default {
    name: 'export-excel-button',
    props: {
        title: String,
        rows: Array,
        trigger: Boolean
    },
    data(){
        return {
            loading: false,
        }
    },
    watch: {
        trigger(){
            this.exportCSV()
        }
    },
    methods: {
        exportCSV: function (){
            this.loading = true;

            // console.log(this.title);
            // console.log(this.rows);
            const wb = XLSX.utils.book_new()
            const ws = XLSX.utils.json_to_sheet(this.rows)
            XLSX.utils.book_append_sheet(wb, ws, this.title)
            XLSX.writeFile(wb, `${this.title}.csv`)
            console.log("done");
            this.loading = false;
        }
    }
}
</script>